export default __webpack_public_path__ + "static/media/Route_east_icon.de293313.svg";